export default __webpack_public_path__ + "static/onboarding2-d07a418c318b04cbb4281af5b745143a.webp";